<template>
    <div>
        <data-loader
            v-if="isLoading"
            message="Generating table data..."
        ></data-loader>

        <div v-if="isLoading == 0">
            <div>
                <h4>
                    {{ pageTitle }}
                </h4>
                <div
                    class="grid grid-cols-2 gap-4"
                    v-if="
                        filter.index.length > 0 &&
                        filter.shape.length > 0 &&
                        filter.jurisdiction.length > 0
                    "
                >
                    <div class="col-span-2 lg:col-span-1">
                        <h5 class="capitalize">
                            {{
                                indexTitle +
                                ", " +
                                jewelOptions.shape.options[filter.shape].title +
                                ", " +
                                (filter.jurisdiction ==
                                jewelOptions.jurisdiction.all_option.key
                                    ? jewelOptions.jurisdiction.all_option.title
                                    : jewelOptions.jurisdiction.options[
                                          filter.jurisdiction
                                      ].title) +
                                " Per Carat (USD)"
                            }}
                        </h5>
                        <div
                            class="my-2 text-xs"
                            v-if="valuationIndexTable.publish_date"
                        >
                            <span class="font-bold;">Publish Date:</span>
                            {{ valuationIndexTable.publish_date }}
                        </div>
                    </div>
                    <div
                        class="
                            col-span-2
                            lg:col-span-1
                            text-right
                            hidden
                            lg:block
                        "
                        v-if="valuationIndexTable.pdf_url"
                    >
                        <a
                            :href="valuationIndexTable.pdf_url"
                            target="_blank"
                            class="btn tertiary btn-download capitalize"
                            >Download Price List<i class="fal fa-download"></i
                        ></a>
                    </div>
                </div>
                <div class="grid grid-cols-6 gap-4 my-4">
                    <div class="col-span-6 sm:col-span-6 text-sm">
                        Select the price &amp; shape you wish to view per carat.
                    </div>
                    <div class="col-span-6 md:col-span-2">
                        <div class="form-item select-single">
                            <div class="flex">
                                <label>Price List: </label>
                                <Tooltip
                                    tooltip="Select the price list data you wish to view"
                                ></Tooltip>
                            </div>
                            <select
                                v-model="filter.index"
                                class="form-select single"
                                @change="getvaluationIndexTable()"
                            >
                                <option value="">-- Select --</option>
                                <option value="auction">
                                    Your Auction Market Price List
                                </option>
                                <option value="wholesale">
                                    Your Wholesale Price List
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-span-6 md:col-span-2">
                        <div class="form-item select-single">
                            <div class="flex">
                                <label>{{ jewelOptions.shape.label }}: </label>
                                <Tooltip
                                    v-if="getHelpText('shape')"
                                    :tooltip="getHelpText('shape')"
                                ></Tooltip>
                            </div>
                            <select
                                v-model="filter.shape"
                                name="shape"
                                class="form-select single"
                                @change="getvaluationIndexTable()"
                            >
                                <option value="">-- Select --</option>
                                <option
                                    v-for="(option, index) in jewelOptions.shape
                                        .options"
                                    :value="index"
                                >
                                    {{ option.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-span-6 md:col-span-2">
                        <div class="form-item select-single">
                            <div class="flex">
                                <label
                                    >{{ jewelOptions.jurisdiction.label }}:
                                </label>
                                <Tooltip
                                    v-if="getHelpText('jurisdiction')"
                                    :tooltip="getHelpText('jurisdiction')"
                                ></Tooltip>
                            </div>
                            <select
                                v-model="filter.jurisdiction"
                                name="jurisdiction"
                                class="form-select single"
                                @change="getvaluationIndexTable()"
                            >
                                <option value="">-- Select --</option>
                                <option
                                    :value="
                                        jewelOptions.jurisdiction.all_option.key
                                    "
                                >
                                    {{
                                        jewelOptions.jurisdiction.all_option
                                            .title
                                    }}
                                </option>
                                <option
                                    v-for="(option, index) in jewelOptions
                                        .jurisdiction.options"
                                    :value="index"
                                >
                                    {{ option.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <notice
                v-if="
                    filter.index == 'auction' &&
                    !isEmpty(valuationIndexTable.result)
                "
                notice-type="info"
                >Auction market pricing data is only available for 1.00ct and
                over.</notice
            >
            <div
                class="std-table-wrapper"
                v-if="!isEmpty(valuationIndexTable.result)"
            >
                <table class="responsive">
                    <tbody class="collapsible">
                        <template
                            v-for="(
                                valuation_data, carat
                            ) in valuationIndexTable.result"
                        >
                            <tr class="font-bold row-">
                                <td
                                    class="header-cell"
                                    @click="caratToggle(carat)"
                                    :colspan="
                                        getCount(jewelOptions.clarity.options) +
                                        1
                                    "
                                >
                                    <span class="mr-4"
                                        >Carat Range: {{ carat }}</span
                                    >
                                    <span
                                        v-if="window.width < 1024"
                                        :class="{
                                            caratOpened:
                                                caratOpened.includes(carat),
                                        }"
                                    >
                                        <span
                                            v-if="!caratOpened.includes(carat)"
                                            key="expand-carat"
                                            class="float-right"
                                            ><i
                                                class="
                                                    fal
                                                    fa-chevron-square-down
                                                    text-primaryBlue-100
                                                "
                                            ></i>
                                            <span
                                                class="
                                                    text-xs text-primaryBlue-100
                                                    font-light
                                                    ml-2
                                                "
                                                >View</span
                                            ></span
                                        >
                                        <span
                                            v-else
                                            key="collapse-carat"
                                            class="float-right"
                                            ><i
                                                class="
                                                    fal
                                                    fa-chevron-square-up
                                                    text-primaryBlue-100
                                                "
                                            ></i
                                            ><span
                                                class="
                                                    text-xs text-primaryBlue-100
                                                    font-light
                                                    ml-2
                                                "
                                                >Hide</span
                                            >
                                        </span></span
                                    >
                                </td>
                            </tr>

                            <tr class="header-row hide-sm">
                                <td>&nbsp;</td>

                                <td
                                    v-for="(
                                        clarity_data, clarity
                                    ) in jewelOptions.clarity.options"
                                >
                                    {{ clarity }}
                                </td>
                            </tr>

                            <tr
                                v-for="(color_data, color) in jewelOptions.color
                                    .options"
                            >
                                <td
                                    class="header-cell"
                                    v-if="
                                        caratOpened.includes(carat) ||
                                        window.width >= 1024
                                    "
                                    @click="colorToggle(carat + color)"
                                >
                                    <span class="mr-4">{{ color }}</span>
                                    <span
                                        v-if="window.width < 1024"
                                        :class="{
                                            colorOpened: colorOpened.includes(
                                                carat + color
                                            ),
                                        }"
                                    >
                                        <span
                                            v-if="
                                                !colorOpened.includes(
                                                    carat + color
                                                )
                                            "
                                            key="expand-color-carat"
                                            class="float-right"
                                            ><i
                                                class="
                                                    fal
                                                    fa-chevron-square-down
                                                    text-primaryBlue-100
                                                "
                                            ></i>
                                            <span
                                                class="
                                                    text-xs text-primaryBlue-100
                                                    font-light
                                                    ml-2
                                                "
                                                >View</span
                                            ></span
                                        >
                                        <span
                                            v-else
                                            key="collapse-color-carat"
                                            class="float-right"
                                            ><i
                                                class="
                                                    fal
                                                    fa-chevron-square-up
                                                    text-primaryBlue-100
                                                "
                                            ></i
                                            ><span
                                                class="
                                                    text-xs text-primaryBlue-100
                                                    font-light
                                                    ml-2
                                                "
                                                >Hide</span
                                            ></span
                                        ></span
                                    >
                                </td>

                                <td
                                    v-if="
                                        colorOpened.includes(carat + color) ||
                                        window.width >= 1024
                                    "
                                    v-for="(
                                        clarity_data, clarity
                                    ) in jewelOptions.clarity.options"
                                >
                                    <span class="col-title">{{ clarity }}</span>
                                    {{
                                        valuationIndexTable.result[carat][
                                            color
                                        ][clarity]
                                    }}
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
function initialState() {
    return {
        isLoading: 1,
        caratOpened: [],
        colorOpened: [],
        window: {
            width: 0,
            height: 0,
        },
        filter: {
            shape: "",
            index: "",
            jurisdiction: "",
            publish_date: "",
            pdf_url: "",
        },
        valuationIndexTable: {},
    };
}

import { mapGetters } from "vuex";
import _find from "lodash/find";
import _pickBy from "lodash/pickBy";
import _isEmpty from "lodash/isEmpty";
export default {
    props: {
        source: {
            type: String,
            required: true,
            default: "",
        },
    },
    data() {
        return initialState();
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
        return this.$store.dispatch("fetchJewelOptions", []).then((res) => {
            this.isLoading = 0;
        });
    },
    methods: {
        isEmpty(data) {
            return _isEmpty(data);
        },
        getvaluationIndexTable() {
            if (
                this.filter.shape.length == 0 ||
                this.filter.index.length == 0 ||
                this.filter.jurisdiction.length == 0
            ) {
                return;
            }
            this.isLoading = 1;
            let tableData = _find(this.valuationIndexTables, {
                shape: this.filter.shape,
                index: this.filter.index,
                jurisdiction: this.filter.jurisdiction,
            });
            if (tableData) {
                //reload what we already have
                this.valuationIndexTable = tableData;
                this.isLoading = 0;
                return;
            } else {
                return this.$store
                    .dispatch("fetchValuationIndexTable", {
                        shape: this.filter.shape,
                        index: this.filter.index,
                        jurisdiction: this.filter.jurisdiction,
                    })
                    .then((res) => {
                        //assign to the local data for display
                        let tableData = _find(this.valuationIndexTables, {
                            shape: this.filter.shape,
                            index: this.filter.index,
                            jurisdiction: this.filter.jurisdiction,
                        });

                        if (tableData.result)
                            this.valuationIndexTable = tableData;
                        this.isLoading = 0;
                    });
            }
        },
        getCount(obj) {
            return this.$fabHelper.getDatalength(obj);
        },
        caratToggle(id) {
            const index = this.caratOpened.indexOf(id);
            if (index > -1) {
                this.caratOpened.splice(index, 1);
            } else {
                this.caratOpened.push(id);
            }
        },
        colorToggle(id) {
            const index = this.colorOpened.indexOf(id);
            if (index > -1) {
                this.colorOpened.splice(index, 1);
            } else {
                this.colorOpened.push(id);
            }
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        getHelpText(field) {
            let helpText = this.jewelOptions[field].helpText[this.source]
                ? this.jewelOptions[field].helpText[this.source].create
                : "";
            return helpText.length > 0 ? helpText : false;
        },
    },
    computed: {
        ...mapGetters(["jewelOptions", "valuationIndexTables"]),
        pageTitle() {
            if (this.filter.index == "auction") {
                return "Your Auction Market Price List";
            } else if (this.filter.index == "wholesale") {
                return "Your Wholesale Price List";
            } else {
                return "Your Diamonds Price Lists";
            }
        },
        indexTitle() {
            if (this.filter.index == "auction") {
                return "Auction";
            } else if (this.filter.index == "wholesale") {
                return "Wholesale";
            } else {
                return "";
            }
        },
    },
};
</script>

<style></style>
